module.exports = __webpack_public_path__ + "static/media/iconUsd.ddaf9b21.svg";